import React, {FC} from "react"
import styled from "styled-components"

import {Body, Label} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {PaymentCurrencyType} from "@irati/types"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"
import {useTheme} from "@irati/ui/src/global/useTheme"

import {FLEXI_PERK, REWARD} from "./"

interface Props {
  text: string
  amount: number
  currencyCode: PaymentCurrencyType
  type?: string
  marginBottom?: number
  isTextLabel?: boolean
}

const IconWrapper = styled(Flex)`
  background: ${({theme}) => theme.colors.primary1};
  height: ${({theme}) => theme.spacing.two};
  width: ${({theme}) => theme.spacing.two};
  border-radius: 100%;
`

const IconTextSavings: FC<Props> = ({type, text, amount, currencyCode, marginBottom, isTextLabel}) => {
  const IconMap = {
    [FLEXI_PERK]: IconTypes.flexiPoints,
    [REWARD]: IconTypes.rewardPoints
  }
  const theme = useTheme()
  const IconComponent = (type && IconMap[type]) || IconTypes.perks
  const TextComponent = isTextLabel ? Label : Body

  return (
    <Flex marginBottom={marginBottom} gap={0.5} alignItems="center">
      {IconComponent === IconTypes.perks ? (
        <IconWrapper justifyContent="center" alignItems="center">
          <Icon icon={IconComponent} size={10} color={theme.colors.greys.white} />
        </IconWrapper>
      ) : (
        <Icon icon={IconComponent} />
      )}
      <TextComponent small>
        <FormattedMessage id={text} values={{amount: formatCurrency({value: amount, currencyCode, isCents: false})}} />
      </TextComponent>
    </Flex>
  )
}

export default IconTextSavings
